export default function ConnectionMoment() {
  return (
    <section
      data-testid="connection-section"
      className="relative bg-[#050505] border-t border-[#262626]"
    >
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[600px]">
        {/* Image side */}
        <div className="relative h-[400px] lg:h-auto overflow-hidden bg-[#0a0a0a]">
          <img
            src="/images/gary-hug-triptych.jpg"
            alt="Gary embracing audience members after a keynote"
            className="w-full h-full object-contain lg:object-cover lg:object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#050505]/40 lg:to-[#050505]/0" />
        </div>

        {/* Copy side */}
        <div className="relative bg-[#EC1985] flex items-center px-8 md:px-16 py-20">
          <div
            className="absolute inset-0 opacity-10 pointer-events-none"
            style={{
              backgroundImage:
                "repeating-linear-gradient(45deg, transparent, transparent 14px, rgba(0,0,0,0.4) 14px, rgba(0,0,0,0.4) 15px)",
            }}
          />
          <div className="relative max-w-xl">
            <div className="text-xs uppercase tracking-[0.3em] font-bold text-white/85 mb-6">
              The Bottom Line
            </div>
            <h2 className="h-display text-4xl md:text-5xl lg:text-6xl text-white">
              When Gary finishes speaking,
              <br />
              the connection
              <br />
              <span className="underline decoration-4 underline-offset-8">doesn't end —</span>
              <br />
              it deepens.
            </h2>
            <p className="mt-8 text-white/95 text-lg leading-relaxed">
              Attendees stay. They engage. They often respond with something as simple
              and powerful as a hug. Gary's authenticity and accessibility reflect what
              he believes speaking should be:
              <span className="font-extrabold"> real human connection.</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
